import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=a505dd3e&"
import script from "./EmailVerification.vue?vue&type=script&lang=js&"
export * from "./EmailVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports